import { render, staticRenderFns } from "./Huisarts.vue?vue&type=template&id=5ff2bb60"
import script from "./Huisarts.vue?vue&type=script&lang=js"
export * from "./Huisarts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports